import { render } from "./AppSidebar.vue?vue&type=template&id=576ab276"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=576ab276&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rlb-poc.prepare.servicedesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__